<template>
  <el-container class="customers">
    <el-header class="header-style">
      <el-divider content-position="left" style="font-size: 0.28em">客户列表</el-divider>
      <div>
        <div style="margin-bottom: 0.3rem">
          <span>
            <strong>会员总数：</strong><strong>{{ mebtotal }}</strong>
          </span>
          <span class="countstyle">
            <strong>关注公众号：</strong><strong>{{ ggzh }}</strong>
          </span>
          <span class="countstyle">
            <strong>未关注公众号：</strong><strong>{{ wgzh }}</strong>
          </span>
          <span class="countstyle">
            <strong>名下有公司：</strong><strong>{{ hasCompany }}</strong>
          </span>
          <span class="countstyle">
            <strong>阅读须知：</strong><strong>{{ readAgree_at }}</strong>
          </span>
          <span class="countstyle">
            <strong>未阅读：</strong><strong>{{ unreadAgree_at }}</strong>
          </span>
        </div>
        <div class="el-col-4">
          <el-input v-model="form.search" placeholder="编号 / 姓名 / 昵称 / 手机号" size="mini" @change="searchSome" clearable>
          </el-input>
        </div>
        <el-popover placement="bottom" width="500" trigger="click" v-model="visible">
          <el-form ref="searchform" :model="searchform" label-width="80px">
            <div>
              <!-- <div style="margin-top: 20px">
              <label for="user_level" class="lstyle">会员身份：</label>
              <el-radio-group v-model="searchform.user_level" size="mini" id="user_level">
                <el-radio-button :label="1">注册会员</el-radio-button>
                <el-radio-button :label="2">财税VIP</el-radio-button>
                <el-radio-button :label="3">月VIP</el-radio-button>
                <el-radio-button :label="4">年VIP</el-radio-button>
              </el-radio-group>
            </div> -->
              <div style="margin-top: 20px">
                <label for="status" class="lstyle">客户状态：</label>
                <el-radio-group v-model="searchform.status" size="mini" id="status">
                  <el-radio-button :label="1">启用</el-radio-button>
                  <el-radio-button :label="'0'">禁用</el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="company" class="lstyle" title="">有无公司：</label>
                <el-radio-group v-model="searchform.company" size="mini" id="company">
                  <el-radio-button label="有"></el-radio-button>
                  <el-radio-button label="无"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="is_clue" class="lstyle" title="">是否线索：</label>
                <el-radio-group v-model="searchform.is_clue" size="mini" id="is_clue">
                  <el-radio-button label="是"></el-radio-button>
                  <el-radio-button label="否"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="is_order" class="lstyle" title="">是否订单：</label>
                <el-radio-group v-model="searchform.is_order" size="mini" id="is_order">
                  <el-radio-button label="是"></el-radio-button>
                  <el-radio-button label="否"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="is_order" class="lstyle" title="">客户意向：</label>
                <el-radio-group v-model="searchform.user_satisfy" size="mini">
                  <el-radio-button label="1">A</el-radio-button>
                  <el-radio-button label="2">B</el-radio-button>
                  <el-radio-button label="3">C</el-radio-button>
                  <el-radio-button label="4">D</el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="is_order" class="lstyle" title="">添加微信：</label>
                <el-radio-group v-model="searchform.is_add_wx" size="mini" id="is_add_wx">
                  <el-radio-button label="是"></el-radio-button>
                  <el-radio-button label="否"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="is_order" class="lstyle" title="">有效沟通：</label>
                <el-radio-group v-model="searchform.valid_chat" size="mini" id="valid_chat">
                  <el-radio-button label="是"></el-radio-button>
                  <el-radio-button label="否"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="own_business" class="lstyle" title="">所属业务：</label>
                <el-cascader style="width: 200px" v-model="searchform.own_business" placeholder="请选择所属业务"
                  :options="ownbusinessOptions" size="mini" @click.native="loadOwnbusiness"
                  :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                  :filter-method="filterOptions">
                </el-cascader>
              </div>
              <div style="margin-top: 20px; white-space: nowrap">
                <label for="own_business" class="lstyle" title="">手机号归属地：</label>
                <el-select v-model="searchform.phone_blp_pro" clearable multiple placeholder="省份" size="mini"
                  style="width: auto" filterable @click.native="loadPhonePro">
                  <el-option v-for="item in phoneProOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
                -
                <el-select v-model="searchform.phone_blp_city" clearable multiple placeholder="城市" size="mini"
                  style="width: auto" filterable @click.native="loadPhoneCity">
                  <el-option v-for="item in phoneCityOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
                <!-- <el-cascader id="classification_of_qualification_certificates_cascader" style="width: 100%"
                  placeholder="手机号归属地" v-model="searchArr.classification_of_qualification_certificates" filterable
                  :props="customPropsEnterpriseCate" size="mini" clearable @visible-change="loadCascaderEnterpriseCate"
                  :options="qualification_certificates_options" v-loading="loading"
                  element-loading-text="数据读取中..."></el-cascader> -->
              </div>
              <div style="margin-top: 20px">
                <label for="customer_source" class="lstyle" title="">客户来源：</label>
                <el-select v-model="searchform.customer_source" clearable placeholder="请选择" id="customer_source"
                  size="mini" style="width: 70%" filterable multiple>
                  <el-option label="企业火小程序" :value="2"> </el-option>
                  <el-option label="企业火官网" :value="5"> </el-option>
                  <el-option label="云上公司注册支付宝小程序" :value="7"> </el-option>
                  <el-option label="云上公司注册微信小程序" :value="8"> </el-option>
                  <el-option label="云上公司注册抖音小程序" :value="9"> </el-option>
                  <el-option label="云上公司注册营销号微信小程序" :value="10">
                  </el-option>
                  <el-option label="企业火公司注册支付宝小程序" :value="11"> </el-option>
                  <el-option label="注册吧企业火小程序" :value="15"> </el-option>
                </el-select>
              </div>
              <div style="margin-top: 20px">
                <label for="gzh" class="lstyle" title="是否关注公众号">公众号：</label>
                <el-radio-group v-model="searchform.gzh" size="mini" id="gzh">
                  <el-radio-button :label="1">是</el-radio-button>
                  <el-radio-button :label="0">否</el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="agree_at" class="lstyle" title="是否阅读须知">阅读须知：</label>
                <el-radio-group v-model="searchform.agree_at" size="mini" id="agree_at">
                  <el-radio-button label="是"></el-radio-button>
                  <el-radio-button label="否"></el-radio-button>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px">
                <label for="regdate" class="lstyle" title="">注册时间：</label>
                <el-date-picker v-model="regdate" type="daterange" range-separator="至" size="mini"
                  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="pickerDataChange"
                  start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
              </div>
            </div>
            <div style="margin-top: 0.4rem; float: right">
              <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
              <el-button size="mini" @click="resetSubmitform">重置</el-button>
            </div>
          </el-form>
          <el-button slot="reference" size="mini" style="margin-left: 10px">筛选</el-button>
        </el-popover>
        <el-popover placement="bottom" width="10" trigger="click" style="float: right">
          <div style="
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              align-content: center;
            ">
            <!-- <el-button size="mini" type="primary" @click="searchRecords">会员搜索记录</el-button>
            <el-button size="mini" type="success" @click="accessRecords">会员访问记录</el-button> -->
            <el-button style="margin: 0.1rem 0 0.2rem 0.2rem; width: 140px; margin-left: 0.2rem" size="mini"
              type="primary" @click="memberLevelSetting">会员等级配置</el-button>
            <el-button style="margin-bottom: 0.2rem" size="mini" type="success"
              @click="memberAccessSetting">会员权限配置</el-button>
            <el-button style="margin-bottom: 0.2rem" size="mini" type="warning" @click="remindGzh">关注公众号提醒</el-button>
            <el-button style="margin-bottom: 0.2rem" size="mini" type="success"
              @click="remindAgree_at">阅读须知提醒</el-button>
            <el-button size="mini" type="primary" @click="mulEditBusiness">更改业务人员</el-button>
          </div>
          <el-button type="primary" size="mini" slot="reference">会员相关操作</el-button>
        </el-popover>
      </div>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 306px)" v-if="!loadingStatus" :data="tableData" border style="width: 100%"
        size="mini" :header-cell-style="{
          background: '#ecf4ff',
          color: '#333',
          fontWeight: '900',
          fontSize: '0.28rem',
        }" @selection-change="getIdForBusiness">
        <el-table-column type="selection" width="55" fixed> </el-table-column>
        <el-table-column prop="id" label="编号" width="90" fixed="left">
        </el-table-column>
        <el-table-column prop="nickname" label="姓名" width="130" fixed="left">
          <template slot-scope="scope">
            <div v-if="scope.row.nickname">{{ scope.row.nickname }}</div>
            <el-popover placement="right" width="300" v-else trigger="click" :disabled="disabled">
              <div>
                <el-form :model="addForm" :rules="rule" ref="addForm" label-width="100px" class="demo-ruleForm"
                  style="margin-left: -47px">
                  <el-form-item label="姓名" prop="niname">
                    <el-input v-model="addForm.niname" size="mini"></el-input>
                  </el-form-item>
                  <el-form-item style="text-align: right">
                    <el-button type="primary" size="mini" @click="tijiao(scope.row)">添加</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div slot="reference" class="el-icon-user" style="cursor: pointer; font-size: 20px" title="添加姓名"></div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="昵称" width="200" fixed="left">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" style="padding: 0; border: none" slot="reference"
              @click="handleShowPayerContent(scope.row)">{{ maskedName(scope.row.name) }}
            </el-link>
            <div>
              <el-tooltip class="item" effect="dark" content="企业火小程序用户" placement="top" v-if="scope.row.is_qyh === 1">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #f56c6c;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                  ">
                  火
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="云上公司注册支付宝小程序用户" placement="top"
                v-if="scope.row.is_ccali === 1">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #409eff;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                  ">
                  支
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="云上公司注册微信小程序用户" placement="top"
                v-if="scope.row.is_ccwc === 1">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #67c23a;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                  ">
                  微
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="企业火公司注册支付宝小程序用户" placement="top"
                v-if="scope.row.is_ccqyh === 1">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #f56c6c;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                  ">
                  企
                </div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="云上公司注册抖音小程序用户" placement="top"
                v-if="scope.row.is_ccbd === 1">
                <!-- <div
                  style="display:inline-block;border-radius:100%;background-color:#F56C6C;color:white;width:20px;height:20px;text-align:center;line-height:20px">
                  抖
                </div> -->
                <div :style="{
                  display: 'inline-block',
                  'border-radius': 100 + '%',
                  'background-color': '#F56C6C;color:white',
                  width: 20 + 'px',
                  height: 20 + 'px',
                  'text-align': 'center',
                  'line-height': 20 + 'px',
                  backgroundImage: 'url(' + bdImg + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% 100%',
                  verticalAlign: 'middle',
                }"></div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="云上公司注册百度小程序用户" placement="top"
                v-if="scope.row.is_ccbaidu === 1">
                <!-- <div
                  style="display:inline-block;border-radius:100%;background-color:#F56C6C;color:white;width:20px;height:20px;text-align:center;line-height:20px">
                  抖
                </div> -->
                <div :style="{
                  display: 'inline-block',
                  'border-radius': 100 + '%',
                  'background-color': '#F56C6C;color:white',
                  width: 20 + 'px',
                  height: 20 + 'px',
                  'text-align': 'center',
                  'line-height': 20 + 'px',
                  backgroundImage: 'url(' + baiduImg + ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '100% 100%',
                  verticalAlign: 'middle',
                }"></div>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="注册吧企业火小程序用户" placement="top"
                v-if="scope.row.is_ccrn === 1">
                <div style="
                    display: inline-block;
                    border-radius: 100%;
                    background-color: #f56c6c;
                    color: white;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                  ">
                  注
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="user_level" label="身份" width="80" fixed="left"></el-table-column>
        <el-table-column prop="sex" label="性别" width="80"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="170">
          <template slot-scope="scope">
            <div style="text-align: center">
              <div style="white-space: nowrap">
                <!-- <el-tooltip class="item" effect="dark" content="点此外呼" placement="top">
                <el-link style="color: #409eff; cursor: pointer" :underline="false" @click="call(scope.row.phone)">{{
                  maskedPhoneNumber(scope.row.phone) }}</el-link>
              </el-tooltip> -->
                <phone-com :comPhone="scope.row.phone" :vagaryPhone="scope.row.vagary_phone"
                  style="display: inline-block" />
                <el-tooltip class="item" effect="dark" content="点此外呼" placement="top">
                  <i @click="
                    call(
                      scope.row.vagary_phone ? scope.row.vagary_phone : scope.row.phone
                    )
                    " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                </el-tooltip>
              </div>
              <div v-if="scope.row.phone_customer_isp">
                {{ scope.row.phone_customer_isp.province }}&nbsp;&nbsp;
                {{ scope.row.phone_customer_isp.city }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否线索">
          <template slot-scope="scope">
            <el-link v-if="scope.row.publicthread" type="primary" :underline="false"
              style="padding: 0; border: none; color: #409eff" slot="reference"
              @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)">是
            </el-link>
            <span v-else class="hide-style" content="否">否</span>
          </template>
        </el-table-column>
        <el-table-column label="是否订单">
          <template slot-scope="scope">
            <el-link v-if="scope.row.tycorders && scope.row.tycorders.length != 0" type="primary" :underline="false"
              style="padding: 0; border: none; color: #409eff" slot="reference"
              @click="handleShowTycOrderRecordOpen(scope.row)">是
            </el-link>
            <span v-else class="hide-style" content="否">否</span>
          </template>
        </el-table-column>
        <el-table-column label="存在未支付订单" width="120">
          <template slot-scope="scope">
            <span v-if="
              scope.row.tyc_we_unpaied_order !== null ||
              (scope.row.cloud_company_reg_mini_pro_ali_loginers &&
                scope.row.cloud_company_reg_mini_pro_ali_loginers.ccrmp_ali_order !==
                null) ||
              (scope.row.cloud_company_reg_mini_pro_bytedance_loginer &&
                scope.row.cloud_company_reg_mini_pro_bytedance_loginer
                  .ccrmp_byte_dance_order !== null) ||
              (scope.row.cloud_company_reg_mini_pro_loginers &&
                scope.row.cloud_company_reg_mini_pro_loginers.ccrmp_wc_order !==
                null) ||
              (scope.row.cloud_company_reg_mini_pro_qyh_loginers &&
                scope.row.cloud_company_reg_mini_pro_qyh_loginers.ccrmp_qyh_order !==
                null)
            ">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="140">
          <template slot-scope="scope">
            <el-radio-group v-model="statusRadio[scope.$index]" size="mini" @change="chooseRadio($event, scope.row.id)">
              <el-radio-button :label="1">启用</el-radio-button>
              <el-radio-button :label="0">禁用</el-radio-button>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="regtime" label="注册时间" width="140">
          <template slot-scope="scope">
            <date-formatter :date-value="scope.row.regtime"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column prop="user_identify_outed_at" label="会员到期时间" width="180"></el-table-column>
        <el-table-column prop="user_from" label="来源" width="200"></el-table-column>
        <el-table-column prop="mycompany_count" label="公司" width="170">
          <template slot-scope="scope">
            <div style="
                display: inline-block;
                text-align: left;
                width: 105px;
                padding: 0.18rem 0;
              ">
              <span v-if="scope.row.mycompany_count === 0">无公司</span>
              <el-badge :value="scope.row.mycompany_count" class="item" type="warning" v-else>
                <el-button type="primary" size="mini" @click="company_table(scope.$index, tableData)" title="公司信息">公司
                </el-button>
              </el-badge>
            </div>
            <div style="display: inline-block; text-align: left; width: 25px">
              <i class="el-icon-circle-plus-outline" style="font-size: 0.43rem; cursor: pointer; vertical-align: middle"
                title="绑定公司" @click="openBind(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="recommend" label="推荐人" width="130">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.recommend && scope.row.recommend.username
                  ? scope.row.recommend.username
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="business.username" label="所属业务" width="150">
          <template slot-scope="scope">
            <el-popover placement="left" width="300" trigger="click" :disabled="businessDisabled">
              <div>
                <div style="color: #409eff; font-size: 0.2rem; margin-bottom: 0.3rem">
                  修改所属业务
                </div>
                <el-cascader style="width: 200px" v-model="clickEditBusiness" placeholder="请选择所属业务"
                  :options="receiverBOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
                  filterable :filter-method="filterOptions">
                </el-cascader>
                <div style="margin-top: 0.3rem; text-align: right">
                  <el-button type="primary" size="mini" @click="doClickEditBus">修改</el-button>
                </div>
              </div>
              <div v-if="scope.row.business !== null" slot="reference" id="smart" style="cursor: pointer"
                title="点击修改所属业务" @click="getCurrentBusiness(scope.$index, scope.row)">
                {{ scope.row.business.username }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="oauthc.subscribe" label="是否关注公众号" width="130">
        </el-table-column>
        <el-table-column prop="agree_at" label="是否阅读须知" width="130">
          <template slot-scope="scope">
            <div>{{ scope.row.agree_at ? "是" : "否" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="agree_at" label="须知阅读时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                <el-button type="text" size="medium" @click="alertChange(scope.row, scope.$index)">编辑</el-button>
              </el-tooltip>
              <el-dropdown trigger="click" style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="searchAccess(scope.row, scope.$index)">搜索和访问</el-dropdown-item>
                  <el-dropdown-item @click.native="grantCouponCode(scope.row, scope.$index)">发放优惠券</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>

          <!-- <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="alertChange(scope.row, scope.$index)"
                circle
              ></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="合同" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-document"
                circle
                @click="handelOpenContract(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="创建订单" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-s-goods"
                circle
                @click="handelOpenCreateOrder(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip> -->

          <!-- <el-tooltip class="item" effect="dark" content="关联订单" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-search"
                circle
                @click="handelOpenUserOrder(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="搜索和访问" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-share"
                circle
                @click="searchAccess(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="绑定共享人" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-user-solid"
                circle
                @click="bindShare(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip> -->
          <!--<el-tooltip-->
          <!--class="item"-->
          <!--effect="dark"-->
          <!--content="绑定推荐人"-->
          <!--placement="top"-->
          <!--v-if="scope.row.recommend == 0"-->
          <!--&gt;-->
          <!--<el-button-->
          <!--type="primary"-->
          <!--size="mini"-->
          <!--icon="el-icon-connection"-->
          <!--circle-->
          <!--@click="adminInfoBinding(scope.row.id)"-->
          <!--&gt;</el-button>-->
          <!--</el-tooltip>-->
          <!-- </template> -->
        </el-table-column>
      </el-table>
      <div v-else class="loading-placeholder">加载中，请稍后...</div>
    </el-main>
    <el-footer class="footer-style">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="nowPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageSize" layout="sizes, total, prev, pager, next, jumper"
        :total="total" background>
      </el-pagination>
    </el-footer>

    <div class="demo-drawer__content" style="padding: 0.2em 1.4em">
      <el-drawer title="修改" :visible.sync="editDialog" direction="rtl" custom-class="demo-drawer" ref="drawer"
        size="55%">
        <el-tabs type="border-card" v-model="userEditTab">
          <el-tab-pane label="用户信息" name="1">
            <el-row style="margin: 0.4rem 0 0.6rem 0">
              <el-col :span="12">
                <span>是否关注公众号: {{ drawer_subscribe }}</span>
                <el-button v-if="drawer_subscribe === '否'" type="primary" size="mini"
                  @click="drawer_sendNotice('subscribe')" style="margin-left: 0.4rem">短信提醒关注公众号</el-button>
              </el-col>
              <el-col :span="12">
                <span>是否阅读须知: {{ drawer_agree_at }}</span>
                <el-button v-if="drawer_agree_at === '否'" type="primary" size="mini"
                  @click="drawer_sendNotice('agree_at')" style="margin-left: 0.4rem">
                  短信提醒阅读须知</el-button>
              </el-col>
            </el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="客户姓名" prop="nickname">
                    <el-input v-model="ruleForm.nickname" size="mini"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户昵称" prop="name">
                    <el-input v-model="ruleForm.name" size="mini"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="ruleForm.phone" size="mini"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属业务" prop="business">
                    <el-cascader style="width: 100%" :key="resetCascader" v-model="ruleForm.business"
                      placeholder="请选择所属业务" :options="businessoptions" size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }" clearable filterable
                      @click.native="getAdminUserOptions" :filter-method="filterOptions"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="客户状态" prop="status">
                    <el-radio-group v-model="ruleForm.status" size="mini">
                      <el-radio-button :label="1">启用</el-radio-button>
                      <el-radio-button :label="0">禁用</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="共享人员">
                    <el-tag style="padding: 0 7px !important" :key="tag.id" v-for="tag in dynamicTags" closable
                      :disable-transitions="false" @close="handleCloseShare(tag.id)">
                      {{ tag.username }}
                    </el-tag>
                    <el-select ref="saveTagInput" class="input-new-tag" @focus="onBlur" v-if="inputVisible"
                      v-model="customerShares" multiple placeholder="请选择" size="mini" filterable
                      @change="setOrderShare">
                      <el-option v-for="item in customerAdminusers" :key="item.id" :label="item.username"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新增</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="客户来源" prop="user_from">
                    <span style="background-color: #e9e9eb">{{
                      ruleForm.user_from
                      }}</span>
                  </el-form-item>
                </el-col>

                <el-col :span="12" style="display: flex; justify-content: flex-end; align-items: center">
                  <el-form-item label="注册时间" prop="regtime">
                    <span style="background-color: #e9e9eb">{{ ruleForm.regtime }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" :offset="12">
                  <el-button type="primary" size="mini" @click="doEdit('ruleForm')">保存</el-button>
                </el-col>
              </el-row>
            </el-form>
            <div v-if="editHistories.length > 0" style="padding: 0.5rem">
              <el-divider content-position="left"><span
                  style="color: #409eff; font-size: 0.3rem; font-weight: bold">修改记录</span></el-divider>
              <el-timeline style="margin-top: 0.5rem">
                <el-timeline-item v-for="(activity, index) in editHistories" :key="index"
                  :timestamp="activity.created_at">
                  <p style="margin-bottom: 0.3rem">{{ activity.ope_name }}</p>
                  <p style="margin-bottom: 0.3rem" v-for="(item, i) in activity.operation" :key="i">
                    {{ item }}
                  </p>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="收件地址" name="2">
            <span style="display: inline-block; text-align: center" slot="label" @click="loadUserAddress">收件地址</span>
            <div style="text-align: right">
              <el-tooltip class="item" effect="dark" content="点击添加地址" placement="top">
                <el-popover placement="left-start" width="500" trigger="click">
                  <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm" label-width="100px">
                    <el-form-item label="收件人" prop="addressee">
                      <el-input v-model="addAddressForm.addressee" size="mini" placeholder="请填写收件人"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="address_phone">
                      <el-input v-model="addAddressForm.address_phone" size="mini" placeholder="请填写手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="收件人区域" prop="receiver_place">
                      <el-select v-model="addAddressForm.receiver_place_pro" placeholder="省" clearable filterable
                        size="mini" style="width: 100%" @click.native="getAddressPro" @change="getAddressCity">
                        <el-option v-for="item in addressProOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select v-model="addAddressForm.receiver_place_city" placeholder="市" clearable filterable
                        size="mini" style="width: 100%" @change="getAddressTown">
                        <el-option v-for="item in addressCityOptions" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select v-model="addAddressForm.receiver_place_town" placeholder="区/县" clearable filterable
                        size="mini" style="width: 100%">
                        <el-option v-for="item in addressTownOptions" :key="item.id" :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收件地址" prop="address">
                      <el-input v-model="addAddressForm.address" size="mini" placeholder="请填写收件地址"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="margin-top: 0.15rem; text-align: right; padding-right: 0.16rem">
                    <el-button type="primary" size="mini" @click="saveChange('addAddressForm')">保存</el-button>
                  </div>
                  <i slot="reference" style="cursor: pointer; font-size: 0.38rem; color: #409eff"
                    class="el-icon-circle-plus-outline"></i>
                </el-popover>
              </el-tooltip>
            </div>
            <el-table :data="userAddressData" style="width: 100%; margin-top: 10px" border size="mini"
              :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem',
              }">
              <el-table-column prop="addressee" label="收件人"> </el-table-column>
              <el-table-column prop="address_phone" label="手机号"> </el-table-column>
              <el-table-column prop="address_phone" label="区域">
                <template slot-scope="scope">
                  <span v-if="scope.row.pro && scope.row.city && scope.row.town">{{
                    scope.row.pro.name +
                    " " +
                    scope.row.city.name +
                    " " +
                    scope.row.town.name
                    }}</span>
                  <span v-else-if="scope.row.pro && scope.row.city && !scope.row.town">{{
                    scope.row.pro.name + " " + scope.row.city.name
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="地址"> </el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="修改" placement="top">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="openEditAddressDialog(scope.row)"
                      circle></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="创建合同" name="3">
            <span style="display: inline-block; text-align: center" slot="label" @click="handelOpenContract">创建合同</span>
            <el-form :model="contractForm" ref="contractForm" label-width="100px" size="mini">
              <el-form-item label="我方企业" prop="tx_company_id">
                <el-select v-model="contractForm.tx_company_id" filterable placeholder="请输入公司名称筛选公司" size="mini"
                  clearable @change="handleTxCompanyChange">
                  <el-option v-for="company in txElectronicCompanies" :key="company.id"
                    :label="company.organization_name" :value="company.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同类型" prop="type">
                <el-radio-group v-model="contractForm.type" size="mini" @change="contractFormTypeChange">
                  <el-radio label="个人" border>个人</el-radio>
                  <el-radio label="企业" border>企业</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="合同模板">
                <span style="display: inline-block; position: relative; bottom: 4px">{{
                  contractForm.template_name
                  }}</span>
                <el-tooltip v-if="showImages.length > 0" class="item" effect="dark" content="模板示例" placement="top">
                  <span style="font-size: 0.5rem; color: #409eff; cursor: pointer" @click="handleShowImagesOpen"><i
                      class="el-icon-question"></i></span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="选择合同模板" placement="top">
                  <i class="el-icon-zoom-in" style="font-size: 0.5rem; color: #409eff; cursor: pointer"
                    @click="handleOpenTemplate"></i>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="企业" v-if="contractForm.type === '企业'">
                <span style="display: inline-block; position: relative; bottom: 4px">{{
                  contractForm.company_name
                  }}</span>
                <el-tooltip class="item" effect="dark" content="选择企业" placement="top">
                  <i class="el-icon-zoom-in" style="font-size: 0.5rem; color: #409eff; cursor: pointer"
                    @click="handleOpenCompany"></i>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="control.componentName" v-for="control in contractForm.controls"
                :key="control.componentId">
                <el-input v-if="
                  control.componentType === 'TEXT' &&
                  control.componentName === '合同费用'
                " v-model="control.componentValue" @change="handleConvert"></el-input>
                <el-input v-else-if="control.componentType === 'TEXT'" v-model="control.componentValue"></el-input>
                <el-input v-else-if="control.componentType === 'MULTI_LINE_TEXT'" type="textarea"
                  v-model="control.componentValue">
                </el-input>
              </el-form-item>
            </el-form>
            <el-row style="padding-top: 0.4rem; float: right">
              <el-col>
                <el-button type="primary" size="mini" @click="submitContractForm('contractForm')">发起合同</el-button>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="创建订单" name="4">
            <span style="display: inline-block; text-align: center" slot="label"
              @click="handelOpenCreateOrder">创建订单</span>
            <el-form ref="orderFrom" :rules="orderRules" :model="orderFrom" label-width="110px" size="mini">
              <el-form-item label="服务事项" prop="pId">
                <el-select v-model="orderFrom.pId" multiple placeholder="选择服务事项">
                  <el-option v-for="(product, index) in otherProducts" :key="index" :label="product.name"
                    :value="product.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="付款金额" prop="price">
                <el-input v-model="orderFrom.price"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input v-model="orderFrom.remark" type="textarea"></el-input>
              </el-form-item>
            </el-form>
            <el-row class="mt-10 tr">
              <el-button type="primary" size="mini" @click="submitCreateOrder('orderFrom')">提 交</el-button>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="关联订单" name="5">
            <span style="display: inline-block; text-align: center" slot="label"
              @click="handelOpenUserOrder">关联订单</span>
            <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
              <el-table :data="userOrderData" size="small" border style="width: 100%; margin-top: 0.2rem" v-cloak>
                <el-table-column label="订单编号" width="150" fixed>
                  <template slot-scope="scope">
                    <el-link class="ellipsis-link" type="primary" @click="handleOrderInfo(scope.row.id)">{{
                      scope.row.order_num }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="订单类型" width="100">
                  <template slot-scope="scope">
                    <el-tooltip v-if="
                      scope.row.order_reg &&
                      scope.row.order_reg.order_reg_name === '单品'
                    " :content="scope.row.meal_singles.length > 0
                          ? getMeals(scope.row.meal_singles)
                          : ''
                        " placement="top">
                      <span class="ellipsis-link" v-if="scope.row.order_reg">
                        {{ scope.row.order_reg.order_reg_name }} :
                        {{ getMeals(scope.row.meal_singles) }}
                      </span>
                      <span v-else>无类型</span>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.order_reg.order_reg_name">
                      <span class="ellipsis-link">
                        {{
                          scope.row.order_reg ? scope.row.order_reg.order_reg_name : ""
                        }}
                      </span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="订单状态" prop="order_status" width="100"></el-table-column>
                <el-table-column label="沟通状态" prop="chat_status"></el-table-column>
                <el-table-column label="沟通专员(业务)" width="120">
                  <template slot-scope="scope">
                    <span class="count-style">{{
                      scope.row.advisor ? scope.row.advisor.username : ""
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="服务状态" prop="service_status"></el-table-column>
                <el-table-column label="服务人员">
                  <template slot-scope="scope">
                    <span class="count-style">{{
                      scope.row.operator_name ? scope.row.operator_name : ""
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="订单金额" prop="total_amount"></el-table-column>
                <el-table-column label="订单来源" prop="platform" width="150"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-drawer>

      <el-dialog title="修改地址" :visible.sync="editAddressDialog" :modal="false" width="30%">
        <el-form :model="editAddressForm" :rules="addressRules" ref="editAddressForm" label-width="100px">
          <el-form-item label="收件人" prop="addressee">
            <el-input v-model="editAddressForm.addressee" size="mini" placeholder="请填写收件人"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="address_phone">
            <el-input v-model="editAddressForm.address_phone" size="mini" placeholder="请填写手机号"></el-input>
          </el-form-item>
          <el-form-item label="收件人区域" prop="receiver_place">
            <el-select v-model="editAddressForm.receiver_place_pro" placeholder="省" clearable filterable size="mini"
              style="width: 100%" @click.native="getAddressPro" @change="getAddressCity">
              <el-option v-for="item in addressProOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="editAddressForm.receiver_place_city" placeholder="市" clearable filterable size="mini"
              style="width: 100%" @change="getAddressTown">
              <el-option v-for="item in addressCityOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="editAddressForm.receiver_place_town" placeholder="区/县" clearable filterable size="mini"
              style="width: 100%">
              <el-option v-for="item in addressTownOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收件地址" prop="address">
            <el-input v-model="editAddressForm.address" size="mini" placeholder="请填写收件地址"></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 0.15rem; text-align: right">
          <el-button type="primary" size="mini" @click="doAddressEdit('editAddressForm')">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog title="绑定公司" :visible.sync="dialogCustomerVisible" width="30%">
        <el-form>
          <div style="text-align: center">
            <el-form-item>
              <span style="
                  color: red;
                  font-size: 0.4rem;
                  font-weight: 500;
                  opacity: 0.5;
                  vertical-align: middle;
                ">*</span>
              <span style="font-size: 0.3rem; font-weight: 500; opacity: 0.5">若未查到公司,请先添加公司</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="companyBind" filterable remote reserve-keyword placeholder="请输入公司名称筛选公司" size="mini"
                clearable :remote-method="companyBindRemote" :loading="bindcLoading" style="width: 100%">
                <el-option v-for="searchCompany in bindCompanyOptions" :key="searchCompany.id"
                  :label="searchCompany.company_name" :value="searchCompany.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="doBind">绑定</el-button>
        </div>
      </el-dialog>
      <el-drawer title="" :visible.sync="table" direction="rtl" size="50%">
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
          <el-row>
            <company-list :userId="companyInfos" :that="obj"></company-list>
          </el-row>
        </div>
        <template slot="title">
          <div style="color: #409eff; font-size: 0.36rem; font-weight: 400">
            {{ this.companyInfoTitle + "的公司" }}
          </div>
        </template>
      </el-drawer>
    </div>
    <el-dialog title="选择模板" :visible.sync="templateVisible">
      <el-table :data="templates" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
        <el-table-column fixed label="模板名称" width="240px">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.name" placement="top">
              <span class="hide-style" style="color: #409eff; cursor: pointer"
                @click="handleDescribeOpen(scope.row.describe)">{{ scope.row.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="模板类型" prop="template_type"></el-table-column>
        <el-table-column label="静默签署" prop="is_silence"></el-table-column>
        <el-table-column label="创建人" prop="founder"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleTemplateSel(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
        :current-page="tplPageOption.currentPage" :page-size="tplPageOption.pageSize" :total="tplPageOption.total"
        @current-change="handleTplCurrentChange">
      </el-pagination>
    </el-dialog>
    <el-dialog title="模板说明" :visible.sync="describeVisible">
      <div>{{ describe }}</div>
    </el-dialog>

    <el-dialog title="选择公司" :visible.sync="companyVisible">
      <el-table :data="txCompanies" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
        <el-table-column label="公司名称" prop="company_name"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleCompanySel(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-drawer title="模板示例" :visible.sync="showImagesDrawer" direction="rtl" :before-close="handleImagesShowBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-image v-for="(image, index) in showImages" :key="index" :src="image.url" lazy></el-image>
      </div>
    </el-drawer>

    <!-- 沟通记录 开始-->
    <el-drawer title="沟通记录" :visible.sync="chatRecordDrawer" direction="rtl" :before-close="handleChatRecordBeforeClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录 结束-->
    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="55%"
      :before-close="handleOrderInfoClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>

    <!-- 用户关联相关订单金额修改 开始-->
    <el-dialog title="修改金额" :visible.sync="totalVisible" width="40%" :before-close="handleTotalClose">
      <div>
        <el-input v-model="changeTotal" size="mini"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleTotalSub">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户关联相关订单金额修改 结束-->
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer :title="'用户详情： ' + userData.name" custom-class="AIdrawer" :visible.sync="handlePayerContentDrawer"
      :show-close="true" :modal="false" :withHeader="true" :wrapperClosable="true" direction="rtl"
      class="AIdrawerWrapper" size="90%" :before-close="handleClose">
      <div class="drawer-title" slot="title">用户详情： {{ userData.name }}</div>
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order :PayerData="userData" :ThreadData="ThreadData" :userOrderData="userOrderWithData"
            :showLogs="showLogs" :bindUserId="bindUserId" ref="user_with_order"></userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->

    <!-- 用户是否订单 开始 -->
    <el-drawer title="订单记录" :visible.sync="tycOrderDrawer" direction="rtl" size="70%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-table :data="userTycOrderList" size="small" border style="width: 100%; margin-top: 0.2rem" v-cloak>
          <el-table-column label="订单号" prop="order_num" width="255">
            <template slot-scope="scope">
              <el-link style="cursor: pointer; color: #409eff" @click="openOrderInfo(scope.row)">{{ scope.row.order_num
                }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="园区" prop="order_park" width="100"></el-table-column>
          <el-table-column label="服务状态" prop="service_status" width="100"></el-table-column>
          <el-table-column label="退款状态" prop="refund_status">
            <template slot-scope="scope">
              <span v-if="scope.row.refund_status == 0">待审核</span>
              <span v-else-if="scope.row.refund_status == 1">已审核</span>
              <span v-else-if="scope.row.refund_status == 2">提交申请</span>
              <span v-else-if="scope.row.refund_status == 3">已完成</span>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="total_amount"></el-table-column>
          <el-table-column label="客户姓名" prop="customer_name"></el-table-column>
          <el-table-column label="客户手机" prop="customer_phone" width="120">
            <template slot-scope="scope">
              <span>{{ maskedPhoneNumber(scope.row.customer_phone) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单来源" prop="platform" width="130"></el-table-column>
          <el-table-column label="沟通顾问" prop="business.username"></el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="150"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 用户是否订单 结束-->
    <el-dialog title="更改业务" :visible.sync="editBusinessVisible" width="30%">
      <el-form>
        <div style="text-align: center">
          <el-form-item>
            <el-cascader style="width: 100%" :key="resetCascader" v-model="mulEditBusinessForm" placeholder="请选择所属业务"
              :options="receiverOptions" size="mini" :props="{ expandTrigger: 'hover', emitPath: false }" clearable
              filterable @click.native="getReceiver" :filter-method="filterOptions">
            </el-cascader>

          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="doMulEditBusiness">更改</el-button>
      </div>
    </el-dialog>
    <el-drawer title="发放优惠券" :visible.sync="couponCodeDrawer" direction="rtl" size="40%"
      :before-close="handleUserCouponCodesFormClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row style="margin-bottom: .2rem;"><span>该用户当前已有优惠券：</span></el-row>
        <el-row style="margin-bottom: .2rem;">
          <label class="code-label" v-for="(item, index) in userCouponCodes" :key="index">
            <span>{{ item.coupon_code_name }} - {{ item.description }} - {{ item.limited_time }}</span>
          </label>
        </el-row>
        <el-row style="margin-bottom: .2rem;"><span>发放优惠券：</span></el-row>
        <el-checkbox-group v-model="userCouponCodesForm.couponCodes" size="mini">
          <el-checkbox v-for="(item, index) in couponCodes" :key="index" :label="item.id" border>{{
            item.coupon_code_name }}
            - {{ item.description }} - {{ item.limited_time }}</el-checkbox>
        </el-checkbox-group>
        <el-row style="text-align: right; margin-top: .2rem;">
          <el-button type="primary" @click="handelSubUserCouponCodesForm" size="mini">提交</el-button>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>
<script>
import OrderInfo from "common/OrderInfo";
import CompanyList from "common/CompanyList";
import ChatRecord from "common/ChatRecord";
import UserwithOrder from "common/UserWithOrder";
import DateFormatter from "common/DateFormatter";
import PhoneCom from "common/PhoneCom";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  components: {
    CompanyList,
    ChatRecord,
    UserwithOrder,
    OrderInfo,
    DateFormatter,
    PhoneCom,
  },
  name: "Customers",
  data() {
    let checkPhone = (rule, value, callback) => {
      if (value !== "") {
        let reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输⼊有效的⼿机号码"));
        }
      }
      callback();
    };
    let validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额"));
      } else {
        value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2);
        value = Number(value).toFixed(2);
      }

      if (value === "NaN") {
        callback(new Error("请输入正确格式的金额"));
      } else {
        this.orderFrom.price = value;
        callback();
      }
    };
    return {
      couponCodeDrawer: false,
      userCouponCodes: [],
      userCouponCodesForm: {
        uid: '',
        couponCodes: []
      },
      couponCodes: [],
      visible: false,
      bdImg: require("../../assets/image/bd.png"),
      baiduImg: require("../../assets/image/baidu.png"),
      inputVisible: false,
      customerShares: [],
      customerAdminusers: [],
      bindShareDialog: false,
      bindUserId: null,
      orderInfoId: null,
      orderInfoVisible: false,
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      // PayerCompanyData: [],
      userOrderWithData: [],
      payerShowTab: "1",
      drawer_name: "",
      drawer_phone: "",
      drawer_subscribe: "",
      drawer_agree_at: "",
      editHistories: [],
      townNone: false,
      loadingStatus: true,
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      // 注册时间
      regdate: [],
      addressProOptions: [],
      addressCityOptions: [],
      addressTownOptions: [],
      editAddressId: null,
      editAddressDialog: false,
      userEditTab: "1",
      userAddressData: [],
      addAddressForm: {
        addressee: "",
        address_phone: "",
        address: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
      },
      editAddressForm: {
        addressee: "",
        address_phone: "",
        address: "",
        receiver_place_pro: "",
        receiver_place_city: "",
        receiver_place_town: "",
      },
      addressRules: {
        addressee: [{ required: true, message: "请输入收件人", trigger: "blur" }],
        address_phone: [
          { required: true, message: "请输入收件人手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入收件人地址", trigger: "blur" }],
      },
      statusRadio: [],
      smart: true,
      clickEditBId: "",
      clickEditRow: "",
      gotodispear: false,
      clickEditBusiness: "",
      businessDisabled: false,
      mulEditBusinessForm: "",
      receiverOptions: [],
      receiverBOptions: [],
      editBusinessVisible: false,
      companyInfoDrawer: false,
      companyInfoTitle: "",
      companyInfos: null,
      tableData: [],
      fenye: "",
      form: {
        search: "",
      },
      total: 1,
      searchform: {
        customer_source: "",
        user_level: "",
        status: "",
        gzh: "",
        agree_at: "",
        delivery: false,
        nickname: "",
        company: "",
        own_business: "",
        start_time: "",
        end_time: "",
        is_clue: "",
        is_order: "",
        user_satisfy: "",
        is_add_wx: "",
        valid_chat: "",
        phone_blp_city: [],
        phone_blp_pro: [],
      },
      phoneProOptions: [],
      phoneCityOptions: [],
      mebtotal: "",
      ggzh: "",
      wgzh: "",
      hasCompany: "",
      readAgree_at: "",
      unreadAgree_at: "",
      editDialog: false,
      eid: "",
      needindex: "",
      addForm: {
        niname: "",
      },
      bindCompanyOptions: [],
      npage: 1,
      nowPage: 1,
      businessoptions: [],
      ownbusinessOptions: [],
      ruleForm: {
        nickname: "",
        name: "",
        phone: "",
        type: [],
        resource: "",
        desc: "",
        business: "",
        status: "",
        regtime: "",
        user_from: "",
      },
      resetCascader: 0,
      obj: "",
      bindId: "",
      searchCompanies: [],
      searchLoading: false,
      bindcLoading: false,
      disabled: false,
      companyData: [],
      table: false,
      cho: "",
      ncho: "",
      loading: false,
      companyBind: "",
      dialogCustomerVisible: false,
      pageSize: 30,
      multipleSelection: [],
      rules: {
        nickname: [
          // { required: true, message: '请输入活动名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入用户昵称", trigger: "blur" },
          {
            min: 1,
            max: 80,
            message: "长度在 1 到 80 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: "blur",
          },
        ],
        region: [{ required: true, message: "请选择活动区域", trigger: "change" }],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [{ required: true, message: "请选择活动资源", trigger: "change" }],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      rule: {
        niname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      contractDrawer: false,
      contractForm: {
        uid: null,
        tx_company_id: "",
        type: "个人",
        template_id: "",
        template_name: "",
        company_id: null,
        company_name: "",
        controls: [],
      },
      templateVisible: false,
      templates: [],
      tplPageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      tplSearchArr: {
        template_type: "个人",
        is_silence: "否",
      },
      companyVisible: false,
      txCompanies: [],
      txElectronicCompanies: [],
      describeVisible: false,
      describe: "",
      showImages: [],
      showImagesDrawer: false,
      otherProducts: [],
      createOrderDrawer: false,
      orderFrom: {
        uId: "",
        pId: [],
        price: "0.00",
        remark: "",
      },
      orderRules: {
        pId: [{ required: true, message: "请选择服务事项", trigger: "blur" }],
        price: [{ required: true, validator: validatePrice, trigger: "blur" }],
      },
      typeInPickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        pId: [{ required: true, message: "请选择服务事项", trigger: "blur" }],
        price: [{ required: true, validator: validatePrice, trigger: "blur" }],
      },
      // 时间控件组件初始化
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      // 控制用户关联订单的显示与隐藏
      userOrderDrawer: false,
      // 单个用户关联的订单记录
      userOrderData: [],
      // 金额修改的显示与隐藏
      changeTotalId: 0,
      changeTotal: 0,
      totalVisible: false,
      // 当前点击的金额所在行索引
      editColumnIndex: "",
      // 控制展开用户有关的订单记录
      tycOrderDrawer: false,
      // 展开用户有关的订单记录
      userTycOrderList: [],
      showLogs: [],
    };
  },
  // directives: {
  //   'mask-phone-number': {
  //     bind(el, binding) {
  //       const phoneNumber = binding.value || el.textContent;
  //       el.textContent = phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  //     }
  //   },
  //   'mask-name': {
  //     bind(el, binding) {
  //       const phoneNumberRegex = /\d{11}/g; // 匹配手机号的正则表达式
  //       const textContent = el.textContent || binding.value;
  //       if (phoneNumberRegex.test(textContent)) {
  //         el.textContent = textContent.replace(phoneNumberRegex, match => {
  //           const replacement = match.substring(0, 3) + '****' + match.substring(7);
  //           return replacement;
  //         });
  //       }
  //       return textContent
  //     }
  //   }
  // },
  computed: {
    tplSearchStr: function () {
      let str = "";
      for (let key in this.tplSearchArr) {
        str += "&" + key + "=" + this.tplSearchArr[key];
      }
      return str;
    },
    dynamicTags() {
      let arr = [];
      this.customerAdminusers.forEach((item) => {
        this.customerShares.forEach((i) => {
          if (item.id === i)
            arr.push({
              id: i,
              username: item.username,
            });
        });
      });
      return arr;
    },
    maskedPhoneNumber() {
      return function (phoneNumber) {
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      };
    },
    maskedName() {
      return function (name) {
        const phoneNumberRegex = /\d{11}/g; // 匹配手机号的正则表达式
        if (phoneNumberRegex.test(name)) {
          return name.replace(phoneNumberRegex, (match) => {
            const replacement = match.substring(0, 3) + "****" + match.substring(7);
            return replacement;
          });
        }
        return name;
      };
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  mounted() {
    this.loadTable();
    this.loadCount();
    this.getReceiverBusiness();
    window.addEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    loadPhonePro() {
      this.$axios
        .get("api/api3_customer_list/get_phone_pro")
        .then(({ data }) => {
          if (data.code === 200) this.phoneProOptions = data.data;
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    handleKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.handlePayerContentDrawer = false;
      }
    },
    // loadPhoneCity(pro_code) {
    //   this.phoneCityOptions = []
    //   if (pro_code.length) {
    //     this.$axios.get('api/api3_customer_list/get_phone_city',{
    //     params: {
    //       pro_code
    //     }
    //   }).then(({data}) => {
    //     if (data.code === 200) this.phoneCityOptions = data.data
    //   }).catch()
    //   }
    // },
    loadPhoneCity() {
      this.$axios
        .get("api/api3_customer_list/get_phone_city", {
          params: {},
        })
        .then(({ data }) => {
          if (data.code === 200) this.phoneCityOptions = data.data;
        })
        .catch();
    },
    // changeOrder(id, contactTime) {
    //   for (let i = 0; i < this.userAddressData.length; i++) {
    //     if (this.userAddressData[i].id === id) {
    //       this.userAddressData[i].contact_time = contactTime
    //     }
    //   }
    // },
    onBlur() {
      this.$refs.saveTagInput.$refs.input.blur = () => {
        this.inputVisible = false;
      };
    },
    handleCloseShare(id) {
      this.customerShares.forEach((item, index) => {
        if (item === id) this.customerShares.splice(index, 1);
      });
      this.$nextTick(() => {
        this.setOrderShare();
      });
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    clearCustomerId() {
      this.bindUserId = null;
    },
    bindShare(row) {
      this.getCustomerShare(row.id);
      this.bindShareDialog = true;
      this.bindUserId = row.id;
    },
    getCustomerShare(id) {
      this.$axios
        .get("api/customer/get_adminuser_share", {
          params: {
            customer_id: id,
          },
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.customerShares = data.data.share;
            this.customerAdminusers = data.data.adminUser;
          }
        })
        .catch();
    },
    call(phone) {
      if (!phone) {
        this.$message.error("手机号为空");
        return;
      }
      // this.$axios.post("/api/admin/call_logs/" + num).then((res) => {
      this.$axios
        .post("api/admin/call_logs_call", {
          phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
            setTimeout(this.getCallLogs(this.order.customer_phone), 500);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    setOrderShare() {
      this.$axios
        .post("api/customer/set_share", {
          customer_id: this.bindUserId,
          shares: this.customerShares,
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.inputVisible = false;
            this.$message.success(data.msg);
          }
        })
        .catch();
    },
    openOrderInfo(row) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = row.id;
      }, 0);
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.handlePayerContentDrawer = true;
      setTimeout(() => {
        this.ThreadData = row.publicthread;
        this.userData = row;
        // this.PayerCompanyData = row.company;
        this.bindUserId = row.id;
        this.handelOpenUserWithOrder(row);
        // if (this.PayerCompanyData.length >= 0) {
        //   for (let item of this.PayerCompanyData) {
        //     item.business_man = row.business.username;
        //   }
        // }
      }, 100);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          this.bindUserId = null;
          this.$refs.user_with_order.showFullNumber = false;
          done();
        })
        .catch((_) => { });
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserWithOrder(row) {
      this.$axios
        .post("/api/customer/get_customer_order", { id: row.id, phone: row.phone })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.userOrderWithData = data.data;
            this.showLogs = data.logs;
            this.bindUserId = row.id;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // adminInfoBinding (id) {
    //   this.$confirm('确认要绑定？')
    //     .then(_ => {
    //       this.$axios
    //         .get('api/customer/bindingreferees?id=' + id)
    //         .then(res => {
    //           if (res.data.code === 1) {
    //             this.$message.success(res.data.msg)
    //             this.loadTable()
    //           }
    //         })
    //         .catch(() => {
    //           this.$message.error('获取数据失败')
    //         })
    //     })
    //     .catch(_ => {})
    // },
    loadTable(page) {
      let pageSize = this.pageSize;
      let userLevel = this.searchform.user_level;
      let gzh = this.searchform.gzh;
      let status = this.searchform.status;
      let agreeat = this.searchform.agree_at;
      let name = this.form.search;
      let ownbusiness = this.searchform.own_business;
      let company = this.searchform.company;
      let starttime = this.searchform.start_time;
      let endtime = this.searchform.end_time;
      let customer_source = this.searchform.customer_source;
      let is_clue = this.searchform.is_clue;
      let is_order = this.searchform.is_order;
      let user_satisfy = this.searchform.user_satisfy;
      let is_add_wx = this.searchform.is_add_wx;
      let valid_chat = this.searchform.valid_chat;
      this.$axios
        .get("api/customer/getcustomer?page=" + this.npage, {
          params: {
            pageSize: pageSize,
            user_level: userLevel,
            gzh: gzh,
            status: status,
            agreeat: agreeat,
            own_business: ownbusiness,
            company: company,
            name: name,
            start_time: starttime,
            end_time: endtime,
            customer_source: customer_source,
            is_clue: is_clue,
            is_order: is_order,
            user_satisfy: user_satisfy,
            is_add_wx: is_add_wx,
            valid_chat: valid_chat,
            params: this.searchform,
            isShow: false,
          },
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
            this.radio();
          }
        })
        .finally(() => {
          this.loadingStatus = false;
        })
        .catch((err) => {
          this.loadingStatus = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder() {
      this.$axios
        .post("/api/customer/get_customer_order", {
          id: this.eid,
          phone: this.drawer_phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.userOrderData = data.data;
            this.bindUserId = this.eid;
            // this.userOrderDrawer = true;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    // 控制金额修改的显示与隐藏
    handleUpTotal(row, index) {
      this.changeTotalId = row.id;
      this.changeTotal = row.total;
      this.totalVisible = true;
      this.editColumnIndex = index;
    },
    // 金额修改弹窗关闭
    handleTotalClose(done) {
      this.changeTotalId = 0;
      this.changeTotal = 0;
      done();
    },
    // 执行金额修改保存
    handleTotalSub() {
      if (!this.changeTotal) {
        this.$message.error("金额不能为空");
        return;
      }
      this.$axios
        .post("/api/admin/we_app_pay_orders/change_total", {
          total: this.changeTotal,
          id: this.changeTotalId,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.userOrderData[this.editColumnIndex]["total"] = data.data.total;
            this.totalVisible = false;
            this.changeTotalId = 0;
            this.changeTotal = 0;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    // 执行退款操作
    handRefund(row) {
      this.$confirm("是否确定退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/api/admin/we_app_pay_orders/refund/" + row.id)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.userOrderData[this.editColumnIndex]["refund_status"] =
                  data.data.refundResult.refund_status;
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        })
        .catch(() => { });
    },
    openBind(val) {
      this.dialogCustomerVisible = true;
      this.bindId = val.id;
    },
    doBind() {
      if (this.companyBind === "") {
        this.$message.error("未选取公司！");
        return false;
      }
      this.$axios
        .get("api/customer/bindcompany", {
          params: {
            uid: this.bindId,
            company_id: this.companyBind,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.dialogCustomerVisible = false;
            this.table = false;
            this.companyInfos = null;
            this.loadTable(this.npage);
            this.loadCount();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.pageSize = val;
      this.loadTable(1);
    },
    companyBindRemote(query) {
      if (query !== "") {
        this.bindcLoading = true;
        this.companyBindSearch(query);
        setTimeout(() => {
          this.bindcLoading = false;
        }, 200);
      } else {
        this.bindCompanyOptions = [];
      }
    },
    companyBindSearch(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.bindCompanyOptions = data.data.companies;
        }
      });
    },
    businessChecked() {
      if (this.business.id === this.businessoptions.id) {
        this.businessChecked = true;
      }
    },
    publicPage(val, par) {
      this.$axios
        .get("/api/customer/getcustomer?page=" + val, {
          params: {
            par,
          },
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.tableData = res.data.data.data;
            this.total = res.data.data.total;
          }
        })
        .catch();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    clearSearch() {
      this.form.search = "";
      this.resetSubmitform();
    },
    searchSome() {
      this.loadTable(1);
      this.nowPage = 1;
    },
    onSubmit() {
      this.visible = false;
      this.npage = 1;
      this.loadTable(1);
      this.nowPage = this.npage;
    },
    alertChange(val, index) {
      this.ruleForm.business = ""; // 初始化
      this.drawer_name = "";
      this.drawer_phone = "";
      this.drawer_subscribe = "";
      this.drawer_agree_at = "";
      this.editHistories = [];
      this.userEditTab = "1";
      this.needindex = index;
      this.eid = val.id;
      this.ruleForm.regtime = val.regtime;
      this.ruleForm.user_from = val.user_from;
      this.drawer_subscribe = val.oauthc ? val.oauthc.subscribe : "否";
      this.drawer_agree_at = val.agree_at ? "是" : "否";
      this.drawer_phone = val.phone;
      this.drawer_name = val.nickname ? val.nickname : val.name;
      this.getEditHistory(val.id);

      this.$axios
        .get("/api/customer/editcustomer?id=" + this.eid)
        .then((res) => {
          if (res.data.code === 1) {
            this.ruleForm.nickname = res.data.data.user.nickname;
            this.ruleForm.name = res.data.data.user.name;
            this.ruleForm.phone = res.data.data.user.phone;
            if (res.data.data.user.status === "启用") {
              this.ruleForm.status = 1;
            } else {
              this.ruleForm.status = 0;
            }

            if (res.data.data.business.length !== 0) {
              this.$nextTick(() => {
                this.getAdminUserOptions();
                this.ruleForm.business = res.data.data.business[0].id;
                this.resetCascader++;
              });
            }
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        });
      this.getCustomerShare(val.id);
      this.bindUserId = val.id;
      this.editDialog = true;
    },
    doEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/customer/doeditcustomer", {
              id: this.eid,
              nickname: this.ruleForm.nickname,
              name: this.ruleForm.name,
              phone: this.ruleForm.phone,
              own_business: this.ruleForm.business,
              status: this.ruleForm.status,
            })
            .then((res) => {
              if (res.data.code === 1) {
                this.$message.success("恭喜你" + res.data.msg);
                this.editDialog = false;
                // this.businessoptions = [];
                this.loadTable(this.npage);
                this.ruleForm.business = "";
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
              this.$message.error("修改失败");
            });
        } else {
          return false;
        }
      });
    },
    addName() { },
    tijiao(s) {
      // s.uid
      if (this.addForm.niname === "") {
        this.$message.error("请填写姓名");
        return false;
      }
      this.$axios
        .post("/api/customer/sdoeditcustomer", {
          id: s.id,
          nickname: this.addForm.niname,
        })
        .then((res) => {
          if (res.data.code === 1) {
            this.addForm.niname = "";
            this.tijiaoVisible = false;
            this.loadTable(this.npage);
          }
        })
        .catch(() => {
          this.$message.error("添加失败");
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    resetSubmitform() {
      this.searchform = this.$options.data().searchform;
      this.searchform.user_level = "";
      this.searchform.status = "";
      this.searchform.gzh = "";
      this.searchform.agree_at = "";
      this.searchform.company = "";
      this.searchform.own_business = "";
      this.searchform.nickname = "";
      this.searchform.start_time = "";
      this.searchform.end_time = "";
      this.searchform.customer_source = "";
      this.searchform.is_clue = "";
      this.searchform.is_order = "";
      this.searchform.user_satisfy = "";
      this.searchform.is_add_wx = "";
      this.searchform.valid_chat = "";
      this.regdate = [];
      this.visible = false;
      this.loadTable(1);
    },
    company_table(row, data) {
      // return
      this.loading = true;
      if (data[row].nickname) {
        this.companyInfoTitle = data[row].nickname;
      } else {
        this.companyInfoTitle = data[row].name;
      }
      this.table = true;
      this.obj = this;
      this.userId = null;
      setTimeout(() => {
        this.companyInfos = data[row].id;
      });
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchArrItemCompanys(query);
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/customer/searchnickname?nickname=" + query).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.searchCompanies = data.data;
        }
      });
    },
    loadOwnbusiness() {
      this.$axios.get("/api/customer/getownbusiness").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.ownbusinessOptions = data.data;
        }
      });
    },
    loadCount() {
      // expmanage/count
      this.$axios.get("/api/expmanage/count").then((res) => {
        if (res.data.code === 1) {
          this.mebtotal = res.data.count.mebtotal;
          this.ggzh = res.data.count.ggzh;
          this.wgzh = res.data.count.wgzh;
          this.hasCompany = res.data.count.hasCompany;
          this.readAgree_at = res.data.count.readAgree_at;
          this.unreadAgree_at = res.data.count.unreadAgree_at;
        }
      });
    },
    mulEditBusiness() {
      this.editBusinessVisible = true;
    },
    doMulEditBusiness() {
      let ids = this.multipleSelection;
      if (ids.length === 0) {
        this.$message.error("请先批量勾选条目！");
        return false;
      }
      let adminUserId = this.mulEditBusinessForm;
      if (adminUserId === "") {
        this.$message.error("未选择所属业务！");
        return false;
      }
      this.$axios
        .put("api/customer/muleditbusiness", {
          ids: ids,
          adminUserId: adminUserId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            this.editBusinessVisible = false;
            this.loadTable(this.npage);
          }
        });
    },
    remindGzh() {
      let ids = this.multipleSelection;
      if (ids.length === 0) {
        this.$message.error("请先批量勾选条目！");
        return false;
      }
      this.$axios
        .get("api/customer/mulsmsforgzh", {
          params: {
            ids: ids,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    remindAgree_at() {
      let ids = this.multipleSelection;
      if (ids.length === 0) {
        this.$message.error("请先批量勾选条目！");
        return false;
      }
      this.$axios
        .get("api/customer/mulsmsgzhforagreeat", {
          params: {
            ids: ids,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getIdForBusiness(val) {
      // console.log(val)
      let ids = val.map((i) => {
        return i.id;
      });
      // console.log(ids)
      this.multipleSelection = ids;
    },
    getReceiver() {
      this.$axios
        // .get("/api/expmanage/getreceiver")
        .get("/api/admin/user/branch")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.receiverOptions = data.data;
          }
        });
    },
    getAdminUserOptions() {
      this.$axios
        // .get("/api/expmanage/getreceiver")
        .get("/api/admin/user/branch")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.businessoptions = data.data;
          }
        });
    },
    getReceiverBusiness() {
      this.$axios
        // .get("/api/expmanage/getreceiver")
        .get("/api/admin/user/branch")
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.receiverBOptions = data.data;
          }
        });
    },
    getCurrentBusiness(index, row) {
      // console.log(row)
      // alert(row.business.id)
      if (!index && !row) {
        return false;
      }
      this.clickEditRow = index;
      this.clickEditBId = row.id;
      this.$axios
        .get("api/customer/getcurrentbusiness?own_business=" + row.business.id)
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.clickEditBusiness = Number(data.data);
          }
        });
    },
    doClickEditBus() {
      this.$axios
        .put(
          "api/customer/editcurrentbusiness?own_business=" +
          this.clickEditBusiness +
          "&id=" +
          this.clickEditBId
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.$message.success(data.msg);
            let myEvent = new Event("click");
            document.dispatchEvent(myEvent);
            this.loadTable(this.npage);
          }
        });
    },
    radio() {
      this.tableData.map((item, index) => {
        if (item.status === "启用") {
          this.statusRadio[index] = 1;
        }
        if (item.status === "禁用") {
          this.statusRadio[index] = 0;
        }
      });
    },
    chooseRadio(val, id) {
      let ifradio = val === 1 ? "启用" : "禁用";
      let userid = id;
      let status = val;
      this.$confirm("确定将此用户状态设为" + ifradio + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .put("api/customer/editstatus", {
              id: userid,
              status: status,
            })
            .then((res) => {
              const { data } = res;
              if (data.code === 1) {
                this.$message({
                  type: "success",
                  message: data.msg,
                });
              }
            });
        })
        .catch(() => {
          this.radio();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    handelOpenContract() {
      this.$axios.get("/api/admin/tx_electronic_companies").then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.txElectronicCompanies = data.data;
          this.contractForm.uid = this.eid;
          // this.contractDrawer = true;
        }
      });
    },
    clearContractForm() {
      this.contractForm.uid = null;
      this.contractForm.tx_company_id = "";
      this.contractForm.type = "个人";
      this.contractForm.template_id = "";
      this.contractForm.template_name = "";
      this.contractForm.company_id = null;
      this.contractForm.company_name = "";
      this.contractForm.controls = [];
      this.txElectronicCompanies = [];
      this.showImages = [];
    },
    handleContractClose(done) {
      this.clearContractForm();
      done();
    },
    contractFormTypeChange(val) {
      if (val === "个人") {
        this.contractForm.company_id = null;
        this.contractForm.company_name = "";
      }
      this.contractForm.controls = [];
      this.contractForm.template_id = "";
      this.contractForm.template_name = "";
      this.showImages = [];
    },
    submitContractForm(formName) {
      if (!this.contractForm.tx_company_id) {
        this.$message.error("我方企业不能为空");
        return;
      }

      if (!this.contractForm.template_id) {
        this.$message.error("合同模板不能为空");
        return;
      }

      if (this.contractForm.type === "企业" && !this.contractForm.company_id) {
        this.$message.error("请选择企业");
        return;
      }

      if (this.contractForm.controls.length > 0) {
        for (let i = 0; i < this.contractForm.controls.length; i++) {
          if (!this.contractForm.controls[i].componentValue) {
            this.$message.error(this.contractForm.controls[i].componentName + "不能为空");
            return;
          }
        }
      }

      this.$axios
        .post("/api/admin/qz_electronic_contract_controller", this.contractForm)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.contractDrawer = false;
            this.clearContractForm();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleOpenTemplate() {
      if (!this.contractForm.tx_company_id) {
        this.$message.error("请先选择我方企业");
        return;
      }
      this.tplSearchArr.template_type = this.contractForm.type;
      this.$axios
        .get(
          "/api/admin/qz_electronic_contract_templates?page=" +
          this.tplPageOption.currentPage +
          this.tplSearchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.templates = data.data.templates.data;
            this.tplPageOption.total = data.data.templates.total;
            this.templateVisible = true;
          }
        });
    },
    handleTplCurrentChange(val) {
      this.tplPageOption.currentPage = val;
      this.handleOpenTemplate();
    },
    handleTemplateSel(row) {
      this.contractForm.template_id = row.template_id;
      this.contractForm.template_name = row.name;
      // this.showImages = row.images
      this.templateVisible = false;
      this.tplPageOption.currentPage = 1;
      this.tplPageOption.total = 0;
      this.tplSearchArr.template_type = "个人";

      this.contractForm.controls = row.components;
    },
    handleOpenCompany() {
      this.$axios
        .get("/api/admin/users/companies/" + this.contractForm.uid)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.txCompanies = data.data.companies.data;
            this.companyVisible = true;
          }
        });
    },
    handleCompanySel(row) {
      this.contractForm.company_id = row.id;
      this.contractForm.company_name = row.company_name;
      this.companyVisible = false;
    },
    handleTxCompanyChange(val) {
      this.contractForm.controls = [];
      this.contractForm.template_id = "";
      this.contractForm.template_name = "";
      this.showImages = [];
      if (val === 1) {
        this.tplSearchArr.is_silence = "是";
      } else {
        this.tplSearchArr.is_silence = "否";
      }
    },
    saveChange(formName) {
      if (this.eid) {
        this.$refs[formName].validate((valid) => {
          if (
            !this.addAddressForm.receiver_place_pro ||
            !this.addAddressForm.receiver_place_city ||
            (!this.addAddressForm.receiver_place_town && this.townNone === false)
          ) {
            this.$message.error("请选择完整收件人区域省市区！");
            return false;
          }
          if (valid) {
            this.$axios
              .post(
                "api/expmanage/storeuseraddressaboutuserid?user_id=" + this.eid,
                this.addAddressForm
              )
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  let myEvent = new Event("click");
                  document.dispatchEvent(myEvent);
                  this.$message.success(data.msg);
                  this.townNone = false;
                  this.loadUserAddress();
                } else {
                  this.$message.error(data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    loadUserAddress() {
      this.userAddressData = [];
      if (this.eid) {
        this.$axios
          .get("api/expmanage/getuseraddressaboutuserid?user_id=" + this.eid)
          .then((res) => {
            const { data } = res;
            if (data.code === 1) {
              this.userAddressData = data.data;
            } else {
              this.$message.error(data.msg);
            }
          });
      } else {
        return false;
      }
    },
    handleDescribeOpen(describe) {
      this.describe = describe;
      this.describeVisible = true;
    },
    handleShowImagesOpen() {
      this.showImagesDrawer = true;
    },
    handleImagesShowBeforeClose(done) {
      done();
    },
    handleConvert(val) {
      val = val.replace(/[^\d.]/g, "");
      val = val.replace(/\.{2,}/g, ".");
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      if (val.indexOf(".") < 0 && val !== "") val = parseFloat(val);
      for (let i = 0; i < this.contractForm.controls.length; i++) {
        if (this.contractForm.controls[i].componentName === "合同费用") {
          this.contractForm.controls[i].componentValue = val;
        }
      }
      this.digitUppercase(val);
    },
    digitUppercase(n) {
      let fraction = ["角", "分"];
      let digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      let unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      let num = Math.abs(n);
      let s = "";
      fraction.forEach((item, index) => {
        s += (digit[Math.floor(num * 10 * 10 ** index) % 10] + item).replace(/零./, "");
      });
      s = s || "整";
      num = Math.floor(num);
      for (let i = 0; i < unit[0].length && num > 0; i += 1) {
        let p = "";
        for (let j = 0; j < unit[1].length && num > 0; j += 1) {
          p = digit[num % 10] + unit[1][j] + p;
          num = Math.floor(num / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }

      let res = s
        .replace(/(零.)*零元/, "元")
        .replace(/(零.)+/g, "零")
        .replace(/^整$/, "零元整");

      for (let i = 0; i < this.contractForm.controls.length; i++) {
        if (this.contractForm.controls[i].componentName === "合同费用大写") {
          this.contractForm.controls[i].componentValue = res;
        }
      }
    },
    doAddressEdit(formName) {
      if (this.editAddressId) {
        this.$refs[formName].validate((valid) => {
          if (
            !this.editAddressForm.receiver_place_pro ||
            !this.editAddressForm.receiver_place_city ||
            (!this.editAddressForm.receiver_place_town && this.townNone === false)
          ) {
            this.$message.error("请选择完整收件人区域省市区！");
            return false;
          }
          if (valid) {
            this.editAddressForm.id = this.editAddressId;
            this.$axios
              .put("api/expmanage/editaddress", this.editAddressForm)
              .then((res) => {
                const { data } = res;
                if (data.code === 1) {
                  this.$message.success(data.msg);
                  this.editAddressDialog = false;
                  this.editAddressId = null;
                  this.townNone = false;
                  this.loadUserAddress();
                } else {
                  this.$message.error(data.msg);
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    openEditAddressDialog(item) {
      this.getAddressPro();
      this.getAddressCity(item.receiver_place_pro);
      this.getAddressTown(item.receiver_place_city);
      this.editAddressId = item.id;
      this.editAddressForm.addressee = item.addressee;
      this.editAddressForm.address_phone = item.address_phone;
      this.editAddressForm.receiver_place_pro = item.receiver_place_pro;
      this.editAddressForm.receiver_place_city = item.receiver_place_city;
      this.editAddressForm.receiver_place_town = item.receiver_place_town;
      this.editAddressForm.address = item.address;
      this.editAddressDialog = true;
    },
    handelOpenCreateOrder() {
      this.$axios.get("/api/admin/tyc_products/other").then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.otherProducts = data.data;
          this.orderFrom.uId = this.eid;
          // this.createOrderDrawer = true;
        }
      });
    },
    clearOrderFrom(formName) {
      this.orderFrom.uid = "";
      this.$refs[formName].resetFields();
    },
    handleCreateOrderClose(done) {
      this.clearOrderFrom("orderFrom");
      done();
    },
    submitCreateOrder(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/users/create_order", this.orderFrom)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.createOrderDrawer = false;
                this.clearOrderFrom("orderFrom");
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        }
      });
    },
    // 会员配置跳转
    memberLevelSetting() {
      this.$router.push({
        path: "/client_manage",
      });
    },
    memberAccessSetting() {
      this.$router.push({
        path: "/client_access",
      });
    },
    // 会员搜索记录查询
    searchRecords() {
      this.$router.push({
        path: "/search_records",
      });
    },
    // 会员访问记录查询
    accessRecords() {
      this.$router.push({
        path: "/access_records",
      });
    },
    // 跳转到传递参数页
    searchAccess(row) {
      this.$router.push({
        path: "/search_access",
        query: {
          uid: row.id,
        },
      });
    },
    getAddressPro() {
      this.$axios.get("api/expmanage/getaddresspro").then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressProOptions = data.data;
        }
      });
    },
    getAddressTown(pid) {
      this.townNone = false;
      this.editAddressForm.receiver_place_town = "";
      this.$axios.get("api/expmanage/getaddresstown?pid=" + pid).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressTownOptions = data.data;
          if (data.data.length === 0) {
            this.townNone = true;
          }
        }
      });
    },
    getAddressCity(pid) {
      this.editAddressForm.receiver_place_city = "";
      this.editAddressForm.receiver_place_town = "";
      this.$axios.get("api/expmanage/getaddresscity?pid=" + pid).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.addressCityOptions = data.data;
        }
      });
    },
    getMeals(meals) {
      let str = "";
      for (let i = 0; i < meals.length; i++) {
        str += meals[i].item_name + "，";
      }
      return str;
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 打开客户对应的订单记录
    handleShowTycOrderRecordOpen(row) {
      this.userTycOrderList = row.tycorders;
      this.userTycOrderList.forEach((item) => {
        item.business = row.business;
      });
      this.tycOrderDrawer = true;
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    // 注册时间控件监听事件
    pickerDataChange(val) {
      console.log(val);
      if (!val) {
        this.searchform.start_time = [];
        this.searchform.end_time = [];
      } else {
        this.searchform.start_time = val[0];
        this.searchform.end_time = val[1];
      }
    },
    LastWeek() {
      const end = new Date();
      const start = new Date();
      const lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);
      return [start, end];
    },
    thisWeek() {
      let Nowdate = new Date();
      let WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      let M = Number(WeekFirstDay.getMonth()) + 1;
      let start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      let WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      let Mon = Number(WeekLastDay.getMonth()) + 1;
      let end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    thisMonth() {
      const end = new Date();
      const start = new Date();
      // 方法1
      const endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    LastMonth() {
      const end = new Date();
      const start = new Date();
      const year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end];
    },
    getEditHistory(userId) {
      this.$axios
        .get("api/customer/get_edit_history?userId=" + userId)
        .then(({ data }) => {
          if (data.code === 1) {
            this.editHistories = data.data;
          }
        })
        .catch();
    },
    drawer_sendNotice(flag) {
      if (!this.drawer_name) {
        return false;
      }
      this.$axios
        .get(
          "api/customer/drawer_send_notice?phone=" +
          this.drawer_phone +
          "&flag=" +
          flag +
          "&nickname=" +
          this.drawer_name
        )
        .then(({ data }) => {
          if (data.code === 1) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    grantCouponCode(row, index) {
      this.$axios.get('/api/admin/grant/get_coupon_codes?uid=' + row.id, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.userCouponCodesForm.uid = row.id
            this.userCouponCodes = data.data.userCouponCodes
            this.couponCodes = data.data.couponCodes.data
            this.couponCodeDrawer = true
          }
        })
    },
    handelSubUserCouponCodesForm() {
      console.log(this.userCouponCodesForm)
      this.$axios.post('/api/admin/grant/coupon_codes', this.userCouponCodesForm, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.couponCodeDrawer = false
            this.$message.success(data.msg)
            this.clearUserCouponCodesForm()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearUserCouponCodesForm() {
      this.userCouponCodes = []
      this.userCouponCodesForm.uid = ''
      this.userCouponCodesForm.couponCodes = []
    },
    handleUserCouponCodesFormClose(done) {
      this.clearUserCouponCodesForm()
      done()
    }
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}

.el-drawer__wrapper>>>.el-drawer {
  overflow-y: auto;
}

.customers {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
}

.footer-style {
  text-align: right;
}

.el-pagination {
  padding-top: 25px;
}

.main-style {
  z-index: 1;
  padding: 0px !important;
  /* overflow-y: auto; */
}

.header-style {
  z-index: 2;
  height: 120px !important;
  padding: 0px !important;
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lstyle {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.countstyle {
  margin-left: 0.4rem;
}

.el-drawer .el-select {
  width: 100%;
}

.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  /*margin-left: 10px;*/
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  /*margin-left: 10px;*/
  vertical-align: bottom;
}

.loading-placeholder {
  text-align: center;
  padding: 20px;
}

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.AIdrawer {
  width: 800px;
  /* 设置遮罩层宽度为抽屉的宽度 */
}

.AIdrawerWrapper {
  width: 800px !important;
  margin-left: auto;
}

.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409eff;
}

.el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}

.el-checkbox.is-bordered.el-checkbox--mini {
  margin-bottom: .2rem;
}

.code-label {
  display: inline-block;
  padding: 3px 15px 3px 10px;
  border-radius: 3px;
  border: 1px solid #DCDFE6;
  font-size: 12px;
  line-height: normal;
  font-weight: 500;
  margin-right: 30px;
  margin-bottom: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/my_customers/Customers.vue